<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <br />
        <PaymentForm class="form-horizontal">
          <FormSection title="Recurrence">
            <div class="frequency">
              <PaymentOptions
                addMonthly
                monthlyText="Monthly donation"
                oneTimeText="One time donation"
              />
            </div>
          </FormSection>
          <FormSection title="Donation Amount">
            <div class="chile__group">
              <AmountSelectorSimple />
              <div class="chile__amount">US Dollars</div>
              <ErrorLabel field="amount" />
            </div>
            <br />
            <div>
              <FormRow inline>
                <FormCol field="custom.listingName" width="half" :showLabel="false">
                  <label class="control-label">Listing name for Dedication</label>
                  <FormInput type="text" />
                </FormCol>
              </FormRow>
              <FormRow inline>
                <FormCol width="half" field="dedicationMessage" />
              </FormRow>
            </div>
          </FormSection>
          <FormSection title="Your Details">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>                   
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donate" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { onMounted } from "vue";
import { defineComponent } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  props: {
    subCampaign: String,
    campaign: String,
  },
  setup(props) {
    const { setValue, form, submit } = usePaymentForm();

    if (props.subCampaign) {
      setValue("applications.0.subCampaign", props.subCampaign);
    }

    if (props.campaign) {
      setValue("applications.0.campaign", props.campaign);
    }

    onMounted(() => {
      const params = queryParams();

      if (params.utm_content) {
        if (
          !["Direct Mail", "Telemarketing", "Text SMS Message"].includes(
            params.utm_content
          )
        ) {
          throw new Error("Invalid subcampaign");
        }

        setValue("applications.0.subCampaign", params.utm_content);
      }
    });

    return {
      form,
      submit,
    };
  },
});
</script>
<style scoped lang="scss">
h2 {
  font-weight: 400;
  margin-bottom: 20px;
  margin-top: 20px;
  font-size: 20px;
  color: black;
}
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.ou-donation-form ::v-deep .styled-radio-container--ou-donation.styled-radio-container {
  .radio-part {
    @media only screen and (min-width: 720px) {
      min-width: 200px;
      max-width: 200px;
    }
  }
}
.ou-donation-form ::v-deep h2 {
  font-size: 20px;
  text-transform: none;
  letter-spacing: normal;
}
label.newsletter__label {
  padding-left: 7px;
}
.control-label {
  flex: 1;
  font-size: 14px;
  padding-top: 3px;
  padding-bottom: 3px;
  display: block;
  color: #222;
}
.donation__list {
  ul {
    padding: 0px 0px;
    margin: 0px 0px 11px;
    display: flex;
    flex-flow: wrap;
    gap: 1%;
    li {
      width: 49%;
      padding: 8px 5px;
      margin-bottom: 8px;
      background: #fafafa;
      text-align: center;
      border: 1px solid #cacaca;
      span {
        font-weight: bold;
        font-size: 18px;
        display: block;
      }
    }
  }
}
.chile__group {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 15px;
}
.holder__links {
  font-size: 18px;
  line-height: normal;
  color: black;
  font-weight: 600;
  padding-bottom: 5px;
  a {
    font-size: 18px;
    line-height: normal;
    font-weight: 600;
  }
}
</style>
